export default {
  TO_TOP: 'toTop',
  TO_BOTTOM: 'toBottom',
  TOP_BOTTOM: 'topBottom'
};
